import { useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { Tile } from 'foundations-components/transitional/components/Tile';
// @ts-ignore no types
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
import { getThankYouData } from 'feedback-public-submission-ui/utils/getThankYouData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ILLUSTRATION_HEIGHT_PIXELS = 164;
const ThankYouTile = ({
  surveyType,
  surveyConfig,
  selectedRating
}) => {
  const {
    hasImage,
    body,
    header,
    illustration,
    imageUrl,
    imageAlt
  } = useMemo(() => getThankYouData(surveyType, selectedRating, surveyConfig), [surveyType, surveyConfig, selectedRating]);
  return /*#__PURE__*/_jsx(Tile, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "thank-you",
      "data-selenium-test": Selectors.THANK_YOU.CONTAINER,
      children: [hasImage && (imageUrl ? /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Image, {
          alt: imageAlt,
          src: imageUrl,
          inlineSize: ILLUSTRATION_HEIGHT_PIXELS.toString()
        })
      }) : /*#__PURE__*/_jsx(Illustration, {
        height: ILLUSTRATION_HEIGHT_PIXELS,
        name: illustration
      })), /*#__PURE__*/_jsxs("div", {
        className: "message-text",
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "THANK_YOU_INPUT_LOADED",
          children: /*#__PURE__*/_jsx("div", {
            className: "thank-you-header",
            "data-selenium-test": Selectors.THANK_YOU.HEADER,
            children: header
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "thank-you-body",
          "data-selenium-test": Selectors.THANK_YOU.BODY,
          dangerouslySetInnerHTML: makeSafeInnerHTML(body)
        })]
      })]
    })
  });
};
export default ThankYouTile;